import React, { useState, useEffect } from "react";
import {
  Col,
  Button,
  //Form,
  FormGroup,
  //Label,
  Input,
  FormText,
} from "reactstrap";


export default function UploadImg({setImg1Url, img1Url, newOfferResetFormTriger, display}) {
    const [input, setInput] = useState('')
    const [uploadedFileUrl, setUploadedFileUrl] = useState('');
    useEffect(() => {
      setUploadedFileUrl('')
      setInput('')
    }, [newOfferResetFormTriger, display])
  const handleUploadFile = async () => {
    const formData = new FormData();

    formData.append("File", input);

    const response = await fetch("/api/Files/Upload/watchHunterItems", {
      method: "POST",
      body: formData,
    });
    const data = await response.text();
    console.log(data);
    setUploadedFileUrl(window.location.origin + data);
    if (response.ok) {
      setInput("");
      console.log('OK BOD')
      setImg1Url( uploadedFileUrl)
      console.log('IMGGGGGGGGGG: ', img1Url)
    }
    if (!response.ok) {
      alert(
        `${data} upload was NOT successful, if you want to try again please reselect your file`
      );
      setInput("");
    }
  };
  return (
    
      <FormGroup row>
        {/*<Label for="exampleFile" sm={2}>File</Label>*/}
        <Col sm={12}>
          <Input
            type="file"
            name={uploadedFileUrl || ''}
            id="exampleFile"
            onChange={(e) => {
              setInput(e.target.files[0]);
            }}
          />
          {input && (
            <Button className="d-flex mt-2" color="success" onClick={handleUploadFile}>
              Upload
            </Button>
          )}
          <FormText name="fileUrl" color="muted">{(uploadedFileUrl) ? uploadedFileUrl : 'No URL'}</FormText>
          {(uploadedFileUrl) && <img src={uploadedFileUrl} alt='uploaded file' style={{maxWidth: '200px', maxHeigth: '200px'}}/>}
        </Col>
      </FormGroup>
    
  );
}
